import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { SelectableOptionGroup, TextAreaGroup } from "../../../common";
import * as style from "../styles.module.scss";

const TypeOfWork = ({
  handleSubmit,
  handleBack,
  state,
  errors,
  handleChange,
}) => {
  const fieldRefs = useRef({});
  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSubmit(fieldRefs);
  };
  return (
    <form
      className={`col-sm-12 col-lg-6 mt-2 mt-lg-4 mb-2 ${style.form}`}
      onSubmit={handleFormSubmit}
    >
      <div>
        <div
          className="form-group"
          ref={(el) => {
            fieldRefs.current.positionSeeking = el;
          }}
        >
          <label htmlFor="positionSeeking">Type of work*</label>
          <TextAreaGroup
            classes={"register_field"}
            inputName="positionSeeking"
            value={state.positionSeeking}
            onChange={(e) => handleChange("positionSeeking", e.target.value)}
            rows={5}
            validationMessageIsRed
            validationMessages={errors?.positionSeeking}
          />
        </div>
        <div className="text-dark mb-hf">
          <p className="mb-0 mt-1">
            Please list at least 5 job types/roles you are seeking, e.g.:
          </p>
          <ul className="pl-1">
            <li>
              Warehouse operative, picker, packer, cleaner, general assistant
            </li>
            <li>
              Administrator, office worker, data entry, receptionist, accounts
              assistant
            </li>
            <li>
              Catering assistant, waiting staff, bar staff, housekeeping, data
              entry
            </li>
          </ul>
        </div>
        <div className="form-group">
          <label htmlFor="driver">
            Do you have a valid UK driving licence?
          </label>
          <SelectableOptionGroup
            selectedOption={state.driver}
            handleOptionChange={(e) => {
              handleChange("driver", e.target.value);
            }}
            options={[
              { value: "no", label: "No" },
              { value: "yes", label: "Yes" },
            ]}
            name="driver"
          />
        </div>
        <div className="form-group">
          <label htmlFor="ownCar">Do you have a car?</label>
          <SelectableOptionGroup
            selectedOption={state.ownCar}
            handleOptionChange={(e) => {
              handleChange("ownCar", e.target.value);
            }}
            options={[
              { value: "no", label: "No" },
              { value: "yes", label: "Yes" },
            ]}
            name="ownCar"
          />
        </div>
      </div>
      <div className={`mt-4 mb-lg-2 ${style.actions}`}>
        <Link to={handleBack}>
          <button className="btn btn-outline-info text-dark mr-1" type="button">
            Back
          </button>
        </Link>
        <button className="btn btn-primary btn-block" type="submit">
          Next
        </button>
      </div>
    </form>
  );
};

export default TypeOfWork;
